<template>
<div>
  <button type="button" @click="toggle_visible"></button>
  <button type="button" @click="show_modal"></button>
  <ul v-show="visible">
    <li>
      <span id="visualizacion">
        <span v-if="filter_has_values">
          <label v-if="is_exacta">{{date_labels[0]}}</label>
          <label v-else>
            <span v-if="date_labels[0] != ''" @click="show_modal">Desde: {{date_labels[0]}}</span>
            <span v-if="date_labels[1] != ''" @click="show_modal">Hasta: {{date_labels[1]}}</span>
          </label>
        </span>
        <span v-else @click="show_modal">
          Filtrar por fecha
        </span>
      </span>
    </li>
  </ul>
  <forms-confirmation-dialog-selector-vue
      :input-selected="dates"
      ref="confirmation"
      @confirm="confirm"
      :component="forms-date-selector"
    />
</div>
</template>

<script>
import mixins from 'common/mixins.js'

export default {
  data() {
    return {
      dates: this.build_dates(this.values)
    }
  },
  components: {
    'forms-confirmation-dialog-selector-vue': () => import(/* webpackChunkName: "[request]" */ "components/forms/ConfirmationDialogSelector")
  },
  computed: {
    date_labels() {
      return this.dates.map((date) => {return date == '' ? '' : date.split('-').reverse().join('/')})
    },
    is_exacta() {
      return this.date_labels[0] == this.date_labels[1]
    },
    filter_has_values() {
      return this.has_values(this.dates)
    }
  },
  methods: {
    build_dates(values) {
      return values.length > 0 ? values.slice() : ['', '']
    },
    show_modal() {
      this.$refs.confirmation[0].showModal()
    },
    confirm(confirmed) {
      this.dates = confirmed
    },
    do_clear() {
      this.dates = ['', '']
    },
    has_values(dates) {
      return dates[0] != '' || dates[1] != ''
    }
  },
  watch: {
    dates(new_value) {
      this.$emit(
        'update_filter',
        this.name,
        this.has_values(new_value) ? new_value.slice() : [],
        this.facet.default_operator
      )
    },
    values(new_value, old_value) {
      this.dates = this.build_dates(new_value)
    }
  },
  mixins: [mixins.facet]
}

</script>